import { Expose } from 'class-transformer';
import { Model } from '../../shared-features/models/model';

export class Coordinate extends Model {
  @Expose() longitude: number;
  @Expose() latitude: number;

  constructor() {
    super();
  }
}
